import { Addon, ModelID, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'addon_id' | 'product_id' | 'name';
export interface AddonSearchParams extends SearchParams<Filter, Sort>, Partial<Addon> {}

export const featurePath = '/v4/location/addon';

export const featureKeys = {
  all: [{ scope: 'addons' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: AddonSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
